module.exports = __webpack_public_path__ + "img/result_obj01.186ff431.png";